import DataGrid from "../../../../../components/DataGrid/DataGrid";
import DetailPanel from "../../../../../components/DetailPanel/DetailPanel";
import { PanelBoxExpanded } from "../../../../../components/DetailPanel/DetailPanel.styles";
import ProgressPanel from "../../../../../components/Progress/ProgressPanel/ProgressPanel";
import ExportButton from "../../ExportButton";
import { ButtonBoxDetails } from "../../ReportList.styles";
import { GlViews } from "../glReportList/GlReportList.hooks";
import { ReportDetailsParams } from "../shared";
import { useReportDetails } from "./ReportDetails.hooks";


type ReportDetailsProps = {
  open: boolean,
  reportParams?: ReportDetailsParams,
  reportView: GlViews,
  summaryRowClicked?: boolean,
  zeroSumStartBalance?: boolean,
  customStartBalanceClicked?: boolean,
  customEndBalanceClicked?: boolean,
  customItdClicked?: boolean,
  level1Clicked?: boolean,
  dateRange?: any

  onClose: () => void
};

export const ReportDetails: React.FC<ReportDetailsProps> = ({ open, reportParams, onClose, reportView, summaryRowClicked, zeroSumStartBalance, customStartBalanceClicked, customEndBalanceClicked, customItdClicked, level1Clicked, dateRange }) => {
  if(!reportParams) return <></>;

  const {
    isLoading,
    dataGridColDefs,
    gridData,
    dateTitle,
  } = useReportDetails(reportParams, reportView, summaryRowClicked!, zeroSumStartBalance!, customStartBalanceClicked!, customEndBalanceClicked!, customItdClicked!, level1Clicked!, dateRange);

  return (
    <>
      <DetailPanel
        id="detail_panel_reports"
        title={`Details ${dateTitle}`}
        open={open}
        hasTabsPanel={false}
        onClose={onClose}
        isGridDisplay={true}
      >
        <PanelBoxExpanded>
          <DataGrid
            id={"report_details"}
            dataList={gridData || []}
            headerList={dataGridColDefs ?? []}
            noDataMessage={isLoading ? "" : undefined}
            minHeight="77vh"
            autoHeight={false}
            checkboxSelection={false}
            disableColumnReorder={true}
          />
          <ButtonBoxDetails>
            <ExportButton
              id="btn_export_wrapper"
              hidden={!gridData.length}
              headers={dataGridColDefs || []}                
              data={gridData || []} 
              fileName={`Ark Report Details ${dateTitle}`}
            /> 
          </ButtonBoxDetails>
        </PanelBoxExpanded>
        <ProgressPanel
          id={"progress_report_detail_panel"}
          showProgress={isLoading}
          text={"Loading..."}
        />
      </DetailPanel>    
    </>
  );
};
